export const categories = [
  {
    name: 'anime',
    image: 'https://i.imgur.com/MpZq2Pr.png',
  },
  {
    name: 'cars',
    image: 'https://i.imgur.com/PQjS0UM.jpg',
  },
  {
    name: 'fitness',
    image: 'https://i.imgur.com/Tm1307W.jpg',
  },
  {
    name: 'wallpaper',
    image: 'https://i.imgur.com/HGBtZaP.jpg',
  },
  {
    name: 'photo',
    image: 'https://i.imgur.com/UHlgtzz.png',
  },
  {
    name: 'food',
    image: 'https://i.imgur.com/VGiScrt.jpg',
  },
  {
    name: 'nature',
    image: 'https://i.imgur.com/2Z6sSTq.jpg',
  },
  {
    name: 'abstract',
    image: 'https://i.imgur.com/ysKHZwi.jpg',
  }, {
    name: 'landscape',
    image: 'https://i.imgur.com/jn5Oz4A.jpg',
  },
  {
    name: 'cats',
    image: 'https://i.imgur.com/H6aXUeF.jpg',
  }, {
    name: 'dogs',
    image: 'https://i.imgur.com/9DnMT9n.jpg',
  },
  {
    name: 'others',
    image: 'https://i.imgur.com/pZ8n38L.jpg',
  },
];

export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
  image{
    asset->{
      url
    }
  },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    } `;

export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _id,
    title, 
    about,
    category,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
   save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    }
  }`;
  return query;
};

export const pinDetailMorePinQuery = (pin) => {
  const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const searchQuery = (searchTerm) => {
  const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
        image{
          asset->{
            url
          }
        },
            _id,
            destination,
            postedBy->{
              _id,
              userName,
              image
            },
            save[]{
              _key,
              postedBy->{
                _id,
                userName,
                image
              },
            },
          }`;
  return query;
};

export const userQuery = (userId) => {
  const query = `*[_type == "user" && _id == '${userId}']`;
  return query;
};

export const userCreatedPinsQuery = (userId) => {
  const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const userSavedPinsQuery = (userId) => {
  const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};
